import React from "react";
import { NavLink } from "react-router-dom";
import { motion as m } from "framer-motion";

const PriceCard = ({
  title,
  description,
  info1,
  info2,
  info3,
  info4,
  info5,
  days,
  times,
  price,
  priceSuffix,
}) => {
  return (
    <div className="hover-div border-solid border-2 border-yellow md:border-black bg-black rounded-lg w-[20rem] p-8 flex flex-col">
      <div className="flex-grow">
        <p className="font-bold text-[30px]">{title}</p>
        <p className="text-[18px] pb-4 italic">{description}</p>
        <p className="text-left">{info1}</p>
        <p className="text-left">{info2}</p>
        <p className="text-left">{info3}</p>
        <p className="text-left">{info4}</p>
        <p className="text-left">{info5}</p>
        <p className="text-[17px] pb-4">{days}</p>
        <p className="text-[17px]">{times}</p>
        <p>
          <NavLink
            to="/schedule"
            className="block font-bold hover:text-yellow focus:text-gray p-6"
          >
            Refer to our Schedule
          </NavLink>
        </p>
        <p className="font-bold text-[25px]">{price}</p>
        <p className="pb-8">{priceSuffix}</p>
      </div>

      {/* Call button */}
      <a
        href="tel:+18057033249"
        className="rounded-full bg-red block px-2 pt-2 pb-2 font-bold mt-auto text-center"
      >
        Call Us
      </a>
    </div>
  );
};

const Pricing = () => {
  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.75, ease: "easeOut" }}
    >
      <center className="pt-28 pb-20">
        {/* ===== KIDS MEMBERSHIPS ===== */}
        <h1 className="font-bold text-[50px] pb-10">Kids Memberships</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mx-auto max-w-4xl justify-items-center pb-20">
          <PriceCard
            title="DIAMOND"
            description="For future champions who want the VIP experience."
            info1="- Unlimited kids BJJ classes (Gi and No-Gi)"
            info2="- 1 Gi included upon sign-up"
            info3="- 1 private lesson per month (scheduled)"
            info4="- Billed monthly via automatic withdrawal"
            info5="- 12-month contract, then month-to-month"
            days="Schedule: Tuesdays and Thursdays"
            times="Time: 4:30pm - 5:15pm"
            price="$229.00"
            priceSuffix="/ month"
          />
          <PriceCard
            title="STARTER"
            description="For busy families just dipping their toes in."
            info1="- 1 class per week (Tues or Thurs)"
            info2="- Automatic monthly billing"
            info3="- Cancel anytime with 30 days' notice"
            info4="- Can upgrade to higher tiers at any time"
            days="Schedule: Tuesdays or Thursdays"
            times="Time: 4:30pm - 5:15pm"
            price="$70.00"
            priceSuffix="/ month"
          />
          <PriceCard
            title="CORE"
            description="For kids ready to build skills, confidence, and consistency. (Most popular)"
            info1="- Unlimited training (2x per week or more)"
            info2="- Includes Gi and No-Gi training with our team of qualified instructors"
            info3="- Most families choose this option for best value and consistency"
            info4="- Billed monthly via automatic withdrawal"
            info5="- 12-month contract, then month-to-month"
            days="Schedule: Tuesdays and Thursdays"
            times="Time: 4:30pm - 5:15pm"
            price="$129.00"
            priceSuffix="/ month"
          />
          <PriceCard
            title="CASH OPTION"
            description="For families who prefer to pay upfront. Please inquire."
            info1="- Customized cash-upfront option available"
            info2="- Inquire for details and tailored pricing"
            days="Schedule: Tuesdays and Thursdays"
            times="Time: 4:30pm - 5:15pm"
          />
        </div>

        {/* ===== ADULT MEMBERSHIPS ===== */}
        <h1 className="font-bold text-[50px] pb-10">Adult Memberships</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mx-auto max-w-4xl justify-items-center">
          <PriceCard
            title="DIAMOND"
            description="For adults who want elite training and personal coaching."
            info1="- Unlimited adult BJJ classes (Gi and No-Gi)"
            info2="- 1 Gi included upon sign-up"
            info3="- 1 private lesson per month (scheduled)"
            info4="- Billed monthly via automatic withdrawal"
            info5="- 12-month contract, then month-to-month"
            price="$249.00"
            priceSuffix="/ month"
          />
          <PriceCard
            title="CORE"
            description="For adults committed to full training and faster progress. (Most popular)"
            info1="- Unlimited adult BJJ training (Gi and No-Gi)"
            info2="- Access to 15 classes per week with our team of qualified instructors"
            info3="- Most chosen option for flexibility and results"
            info4="- Billed monthly via automatic withdrawal"
            info5="- 12-month contract, then month-to-month"
            price="$149.00"
            priceSuffix="/ month"
          />
          <PriceCard
            title="CASH OPTION"
            description="For adults who prefer to pay upfront."
            info1="- Customized cash-upfront option available"
            info2="- Inquire for details and tailored pricing"
          />
        </div>
      </center>
    </m.div>
  );
};


export default Pricing;
